// extracted by mini-css-extract-plugin
module.exports = {"inputs":"provider-edit_inputs_AGmjT","products":"provider-edit_products_1boSm","product":"provider-edit_product_2vI_0","productCheckbox":"provider-edit_productCheckbox_3scR6"};